module.exports = __webpack_public_path__ + "img/gray-search.5ec65d0d.svg";